import React from 'react'
import { Container, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux'
import { selectTranslations } from 'redux/selector'
import { PAGE_IDS, PAGE_TYPES, TRANSLATIONS } from 'config/constants'
import { ProductDetailItemType, TextItemType } from 'types'
import {
  getEquipmentTable,
  getShortDescriptionTable,
  getTechDataTable,
} from 'config/utils/ComparisonFunction'
import ImagesSection from '../components/ImagesSection'
import TechDataCompare from '../components/TechDataCompare'
import EquipmentCompare from '../components/EquipmentCompare'
import DescriptionCompare from '../components/DescriptionCompare'
import useJSPDF from 'features/PDF/hooks/useJSPDF'

type ComparisonUIProps = {
  productCompareDetails: ProductDetailItemType[]
}

const ComparisonUI = ({ productCompareDetails }: ComparisonUIProps) => {
  const translations = useSelector(selectTranslations)

  const { openNewPDFWindow } = useJSPDF()

  const onExportProductCompare = () => {
    openNewPDFWindow([{
      type: PAGE_TYPES.COMPARISON,
      pageId: PAGE_IDS.COMPARISON_SCREEN
    }])
  }

  const productComparison = translations.product_comparison ?? TRANSLATIONS.productComparison
  const exportTxt = translations.export ?? TRANSLATIONS.export
  const noProductTxt =
    translations.no_product_is_added_for_comparison_alert ??
    TRANSLATIONS.noProductAreSelectedForComparison

  const compareListTechdata = productCompareDetails.map((item) => item.techdata)
  const equipmentsCompareData = productCompareDetails.map((item) => item.equipment)
  const descriptionsData: TextItemType[] = productCompareDetails
    .map((item) => item.texts.find((text) => text.type === 'short'))
    .filter((text): text is TextItemType => Boolean(text))
  const techDataTable = getTechDataTable(compareListTechdata)
  const equipmentsTable = getEquipmentTable(equipmentsCompareData)
  const descriptionTable = getShortDescriptionTable(descriptionsData)

  const renderHeader = () => {
    if (productCompareDetails.length === 0) {
      return (
        <Row>
          <h1 className='ak-bold mt-3'>{productComparison.toUpperCase()}</h1>
          <h5 className='text-center m-5'>{noProductTxt}</h5>
        </Row>
      )
    }
    return (
      <Row className='d-flex align-items-center'>
        <div className='d-flex align-items-center'>
          <h1 className='ak-bold mt-3'>{productComparison.toUpperCase()}</h1>

          <span className='px-4'>
            <i className='karcher-icon'>&#xe843;</i>
          </span>

          <div
            className='d-flex align-items-center px-3 cursor-pointer'
            onClick={onExportProductCompare}
          >
            <i className='karcher-icon'>&#xe914;</i>
            <span className='export-text'>{exportTxt}</span>
          </div>
        </div>
      </Row>
    )
  }

  return (
    <Container>
      {renderHeader()}

      <ImagesSection productCompareDetails={productCompareDetails} />

      <TechDataCompare techDataTable={techDataTable} />

      <EquipmentCompare equipmentsTable={equipmentsTable} />

      <DescriptionCompare descriptionTable={descriptionTable} />
    </Container>

  )
}

export default ComparisonUI
